import client from 'api/client';

import { createPaginationValues, createURLParams } from 'utils/urls';

export const addUser = async payload => {
  const { data } = await client.post(`users/`, payload);
  return data;
};
export const deleteUser = async pk => {
  const { data } = await client.delete(`users/${pk}/`);
  return data;
};
export const getCurrentUser = async () => {
  const { data } = await client.get('users/current/');
  return data;
};

export const findAndUpdateUser = async payload => {
  const { data } = await client.patch(`users/${payload.id}/`, payload);
  return data;
};

export const updateLoginEmail = (id, payload) => client.post(`users/${id}/reset-email/`, payload);

export const getAllPermissions = async payload => {
  const { data } = await client.get('users/all-permissions/', { params: payload });
  return data;
};

export const checkEligibilityEvent = ({ id, checkMethod, checkData }) => {
  const payload = { checkMethod, checkData };
  return client.post(`users/${id}/check-eligibility-event/`, payload);
};

export const getLoginDetails = id => client.post(`users/${id}/login-details/`);

// Claims User API
export const findAndUpdateClaimsUser = async (id, payload) => {
  const { data } = await client.patch(`users/claim-users/${id}/`, payload);
  return data;
};

export const addClaimsUser = async payload => {
  const { data } = await client.post('users/claim-users/', payload);
  return data;
};

export const getClaimsReviewers = async ({ pageSize, pageIndex, ...filters } = {}) => {
  const pagination =
    pageSize != null || pageIndex != null ? createPaginationValues({ pageSize, pageIndex }) : {};
  const params = createURLParams({
    ...pagination,
    ...filters,
    reviewer_only: true,
    include_license_info: true,
  });
  const { data } = await client.get('users/claim-users/', { params });
  return data;
};

export const getClaimUser = async (id, { includeLicenseInfo } = {}) => {
  const params = createURLParams({ include_license_info: includeLicenseInfo });
  const { data } = await client.get(`users/claim-users/${id}/`, { params });
  return data;
};

export const getAllClaimsUsers = async ({ pageSize, pageIndex, search }) => {
  const { limit, offset } = createPaginationValues({ pageSize, pageIndex });
  const queryParams = createURLParams({
    limit,
    offset,
    ...(search || {}),
  });
  const { data } = await client.get('users/claim-users/', { params: queryParams });
  return data;
};
